import React, {Component} from "react";
import {DatePicker, Select} from "antd";
import {orderBy, map} from "lodash";
import moment from "moment-timezone";
import Loader from "../../../../Common/Component/Loader";
import {errorHandle} from "../../../../Common/errorHandle";
import {formatToCurrency} from "../../../../../Tools/formatToCurrency";

const {Option} = Select;

class Revenue extends Component {
  state = {
    franchiseList: {},
    franchise_uuid: '',
    month: moment(),
    summary: {},
    loader: false,
    user_uuid:null
  }

  componentDidMount() {
    const {franchise_uuid, month} = this.state;
    this.setState({loader: true})
    this.props.getFranchiseList();
    this.getLoggedInUserRole()
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    //get franchise list
    if (Object.keys(nextProps?.FranchiseList?.data).length > 0 && nextProps.FranchiseList.data !== this.props.FranchiseList.data) {
      this.setState({
        franchiseList: nextProps?.FranchiseList?.data,
        loader: false
      })
    }
    if (Object.keys(nextProps?.FranchiseList?.errors).length > 0 &&
      JSON.stringify(nextProps?.FranchiseList?.errors) !== JSON.stringify(this.props?.FranchiseList?.errors)) {
      // display error messsage
      errorHandle(nextProps?.FranchiseList?.errors)
      this.setState({loader: false})
    }

    //get sales tax summary
    if (Object.keys(nextProps.SalesByItem.summary).length > 0 && nextProps.SalesByItem.summary !== this.props.SalesByItem.summary) {
      this.setState({
        summary: nextProps.SalesByItem.summary,
        loader: false
      })
    }

    // error
    if (Object.keys(nextProps.SalesByItem.errors).length > 0 && nextProps.SalesByItem.errors !== this.props.SalesByItem.errors) {
      // display error message
      errorHandle(nextProps.SalesByItem.errors)
      this.setState({loader: false})
    }

  }

  // get logged in user
  getLoggedInUserRole = () => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    // const franchise_uuid = authUser?.user?.associated_field_offices?.map(x => x.uuid);
    // this.setState({franchise_uuid: franchise_uuid?.[0]})
    this.props.getSalesTaxSummary({user_uuid:authUser?.user?.role[0]==='admin' || this.state.franchise_uuid!==''?'':authUser?.user?.uuid,field_office__uuid: this.state.franchise_uuid, created_at__month: moment(this.state.month).format('MM'), created_at__year: moment(this.state.month).format('YYYY')})

  }

  // on service detail change
  onTextChange = (e, type) => {
    let authUser = JSON.parse(localStorage.getItem('authUser'))
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value, loader: true }, () => {
      const {franchise_uuid, month} = this.state;
      this.props.getSalesTaxSummary({user_uuid:authUser?.user?.role[0]==='admin' || this.state.franchise_uuid!==''?'':authUser?.user?.uuid,field_office__uuid: franchise_uuid, created_at__month: moment(month).format('MM'), created_at__year: moment(month).format('YYYY')})
    })
  }

  renderTableBody = (item) => {
    return (
      <div className="frbody">
        <div className={'frleft'}>
          <p>{item?.line_items__description}</p>
        </div>
        <div className="fright">
          <div className={"flex"}>
            <div className="flex-1">{item?.taxable_sales? `$ ${formatToCurrency(item?.taxable_sales)}` : '$ 0.00'}</div>
            <div className="flex-1">{item?.non_taxable_sales ? `$ ${formatToCurrency(item?.non_taxable_sales)}` : '$ 0.00'}</div>
            <div className="flex-1">{item?.total ? `$ ${formatToCurrency(item?.total)}` : '$ 0.00'}</div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {franchiseList, franchise_uuid, month, summary, loader} = this.state;
    const franchise_name = franchiseList?.results?.filter(x => x.uuid === franchise_uuid)
    return (
      <div className="sales-item rev-sales">
        {loader && <Loader />}
        <div className="right_side">
          <div className="form-group flex ai-center fltr-txt">
            <div className="fitem">
              <Select
                className="swhite franchise_filter"
                id={"customerFranchise"}
                showArrow={true}
                suffixIcon={<i className="las la-angle-down"></i>}
                value={franchise_uuid || "All"}
                onChange={(e) => this.onTextChange({target: {name: 'franchise_uuid', value: e}})}
              >
                <Option key={"All"} value="">All</Option>
                {
                  orderBy(franchiseList?.results, 'id', 'asc')?.map((option) =>
                    <Option key={option?.uuid} value={option?.uuid}>{option?.name}</Option>)
                }
              </Select>
            </div>
            <div className="fitem">
              <DatePicker
                disabledDate={(current) => { return current && current >= moment().endOf('month'); }}
                format="MMM YYYY"
                picker="month"
                value={month ? month : moment()}
                allowClear={false}
                onChange={(e) => this.onTextChange({target: {name: 'month', value: e}})}
                className="form-control" />
            </div>
          </div>
        </div>
        <div className="frtable">
          {/* header */}
          <div className="frtop">
            <div className="frleft">
              <p>Franchise: {franchise_name?.[0]?.city?franchise_name?.[0]?.city+","+ franchise_name?.[0]?.state:"ALL"} <br /> for period {moment(month).format('MMMM')} {moment(month).format('YYYY')}</p>
            </div>
          </div>

          {/*Body*/}
          <div className="frhead" style={{backgroundColor:"white"}}>
            <div className="frleft">
              {/* <h4>Product/Service Sales</h4> */}
            </div>
            <div className="fright">
              <div className={"flex"}>
                <div className="flex-1"><h4>Taxable Sales</h4></div>
                <div className="flex-1"><h4>Non-Taxable Sales</h4></div>
                <div className="flex-1"><h4>Total</h4></div>
              </div>
            </div>
          </div><br/>
          <div className="frhead">
            <div className="frleft">
              <h4>Product</h4>
            </div>
            <div className="fright">
              <div className={"flex"}>
                <div className="flex-1"><h4></h4></div>
                <div className="flex-1"><h4></h4></div>
                <div className="flex-1"><h4></h4></div>
              </div>
            </div>
          </div>
          {map(summary?.product_tax?.result, this.renderTableBody)}
          <br/>
          <div className="frbody">
            <div className={'frleft'}>
              <p></p>
            </div>
            <div className="fright">
              <div className={"flex"}>
                <div className="flex-1"><p>{summary?.product_tax?.total_taxable_sales? `$ ${formatToCurrency(summary?.product_tax?.total_taxable_sales)}` : '$ 0.00'}</p></div>
                <div className="flex-1"><p>{summary?.product_tax?.total_non_taxable_sales ? `$ ${formatToCurrency(summary?.product_tax?.total_non_taxable_sales)}` : '$ 0.00'}</p></div>
                <div className="flex-1"><p>{summary?.product_tax?.total_sales ? `$ ${formatToCurrency(summary?.product_tax?.total_sales)}` : '$ 0.00'}</p></div>
              </div>
            </div>
          </div>
          <br/>
          <div className="frhead">
            <div className="frleft">
              <h4>Service</h4>
            </div>
            <div className="fright">
              <div className={"flex"}>
                <div className="flex-1"><h4></h4></div>
                <div className="flex-1"><h4></h4></div>
                <div className="flex-1"><h4></h4></div>
              </div>
            </div>
          </div>
          {map(summary?.service_tax?.result, this.renderTableBody)}
          <br/>
          <div className="frbody">
            <div className={'frleft'}>
              <p></p>
            </div>
            <div className="fright">
              <div className={"flex"}>
                <div className="flex-1"><p>{summary?.service_tax?.total_taxable_sales? `$ ${formatToCurrency(summary?.service_tax?.total_taxable_sales)}` : '$ 0.00'}</p></div>
                <div className="flex-1"><p>{summary?.service_tax?.total_non_taxable_sales ? `$ ${formatToCurrency(summary?.service_tax?.total_non_taxable_sales)}` : '$ 0.00'}</p></div>
                <div className="flex-1"><p>{summary?.service_tax?.total_sales ? `$ ${formatToCurrency(summary?.service_tax?.total_sales)}` : '$ 0.00'}</p></div>
              </div>
            </div>
          </div>
          <br/>
          {/*  footer*/}
          <div className="frfoot mt-20">
            <div className="frleft">
              <h4>Total Revenue</h4>
            </div>
            <div className="fright">
              <div className="flex">
                <div className="flex-1 mt-0">
                  <h4>{summary?.total_taxable_sales ? `$ ${formatToCurrency(summary?.total_taxable_sales)}` : '$ 0.00'}</h4>
                </div>
                <div className="flex-1 mt-0">
                  <h4>{summary?.total_non_taxable_sales ? `$ ${formatToCurrency(summary?.total_non_taxable_sales)}` : '$ 0.00'}</h4>
                </div>
                <div className="flex-1 mt-0">
                  <h4>{summary?.total_sales_tax ? `$ ${formatToCurrency(summary?.total_sales_tax)}` : '$ 0.00'}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Revenue